import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var OutModes = /*#__PURE__*/function () {
  function OutModes() {
    _classCallCheck(this, OutModes);

    this.default = "out";
  }

  _createClass(OutModes, [{
    key: "load",
    value: function load(data) {
      var _data$bottom, _data$left, _data$right, _data$top;

      if (!data) {
        return;
      }

      if (data.default !== undefined) {
        this.default = data.default;
      }

      this.bottom = (_data$bottom = data.bottom) !== null && _data$bottom !== void 0 ? _data$bottom : data.default;
      this.left = (_data$left = data.left) !== null && _data$left !== void 0 ? _data$left : data.default;
      this.right = (_data$right = data.right) !== null && _data$right !== void 0 ? _data$right : data.default;
      this.top = (_data$top = data.top) !== null && _data$top !== void 0 ? _data$top : data.default;
    }
  }]);

  return OutModes;
}();